import '@popperjs/core';

class Header {
  constructor() {
    this.stickyHeader();
    this.megaMenu();
    this.hamburger();
    this.megamenuPopup();
    //this.searchPopup();
    this.bgColorChange();
    this.hoverEvents();
    this.linkAnimatedLine();
    this.stickyBanner();
  }

  stickyHeader() {
    if (50 > window.scrollY) {
      $('.theme-header').addClass('sticky');
    }

    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 50) {
        $('.theme-header').addClass('sticky');
        $('.menu-toggler').addClass('sticky-active');
        $('.pushy').addClass('sticky-active');
      } else {
        $('.theme-header').removeClass('sticky');
        $('.menu-toggler').removeClass('sticky-active');
        $('.pushy').removeClass('sticky-active');
      }
    });
  }

  // Click Event
  hoverEvents() {
    $('.mega-menu-list ul li').hover(
      function () {
        $(this).parent('ul').addClass('active'); //Add an active class to the anchor
      },
      function () {
        $(this).parent('ul').removeClass('active'); //Remove an active class to the anchor
      }
    );
  }

  megaMenu() {
    const $body = document.querySelector('body');
    var $mainMenu = document.querySelectorAll(
        '.main-nav--js ul li.menu-item-submenu'
      ),
      menuLink = document.querySelectorAll('.mega-menu-wrapper .mega-menu');
    for (let i = 0; i < $mainMenu.length; i++) {
      $mainMenu[i].addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          var elem = $(event.currentTarget);
          var menuID = elem.attr('data-menuid');
          var megaMenuClass = document.querySelector('.mega-menu.' + menuID);
          megaMenuClass.classList.toggle('is-open');
          megaMenuClass.classList.toggle('is-closed');
          var isActive = elem.find('span.menu--js').hasClass('is-menu-active');

          if (!isActive) {
            $('.main-nav--js ul li.menu-item span.menu--js').removeClass(
              'is-menu-active'
            );
            elem.find('span.menu--js').addClass('is-menu-active');
            $body.classList.add('mega-menu--open');
            $('.menu-toggle-search-lg').removeClass('is-active');
            $('.theme-header').addClass('theme-header--is-open');
          } else {
            $body.classList.remove('mega-menu--open');
            $('.theme-header').removeClass('theme-header--is-open');
            elem.find('span.menu--js').removeClass('is-menu-active');
          }

          menuLink.forEach(function (item) {
            if (!item.classList.contains(menuID)) {
              item.classList.remove('is-open');
              item.classList.add('is-closed');
            }
          });
        },
        false
      );
    }

    $('.mega-menu-close').on('click', function (e) {
      e.preventDefault();
      if ($('.mega-menu').hasClass('is-open')) {
        $('.mega-menu').removeClass('is-open');
        $('.mega-menu').addClass('is-closed');
        $('.menu-toggle-search-lg').removeClass('is-active');
        $('body').removeClass('overflow-hidden mega-menu--open');
        $('.theme-header').removeClass('theme-header--is-open');
        $('.main-nav--js ul li.menu-item span.menu--js').removeClass(
          'is-menu-active'
        );
      }
    });
  }

  linkAnimatedLine() {
    var linkAnimate = document.querySelectorAll('.link-animated-line');
    if (linkAnimate.length > 0) {
      $('.link-animated-line > a').wrapInner($('<span class="main"></span>'));
      $('.link-animated-line > a').prepend(
        '<span class="the-arrow -left"><span class="shaft"></span> </span>'
      );
    }
  }

  // Hamburger Menu
  hamburger() {
    // Hamburger Menu
    var forEach = function (t, o, r) {
      if ('[object Object]' === Object.prototype.toString.call(t))
        for (var c in t)
          Object.prototype.hasOwnProperty.call(t, c) && o.call(r, t[c], c, t);
      else for (var e = 0, l = t.length; l > e; e++) o.call(r, t[e], e, t);
    };

    var hamburgers = document.querySelectorAll('.hamburger');

    if (hamburgers.length > 0) {
      forEach(hamburgers, function (hamburger) {
        hamburger.addEventListener(
          'click',
          function () {
            this.classList.toggle('is-menu-active');
          },
          false
        );
      });
    }

    $('.hamburger').on('click', function () {
      $('.theme-header').toggleClass('theme-header--is-open');
      $('body').toggleClass('pushy-open-right overflow-hidden mega-menu--open');
      if ($('.mega-menu').hasClass('is-open')) {
        $('.mega-menu').removeClass('is-open');
        $('.mega-menu').addClass('is-closed');
        $('.offcanvas-menu span.menu--js').removeClass('is-menu-active');
      }
    });

    var $toggleCaseLg = document.querySelectorAll('.mobile-menu-back'),
      body = document.querySelector('body');

    for (let i = 0; i < $toggleCaseLg.length; i++) {
      $toggleCaseLg[i].addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          $('.mega-menu-wrapper .mega-menu').addClass('is-closed');
          $('.mega-menu-wrapper .mega-menu').removeClass('is-open');
          $('.offcanvas-menu span.menu--js').removeClass('is-menu-active');
          // body.classList.toggle('overflow-hidden');
        },
        false
      );
    }
  }

  bgColorChange() {
    $(window)
      .scroll(function () {
        // selectors
        var $window = $(window),
          $body = $('body'),
          $panel = $('.bg-transition');

        // Change 33% earlier than scroll position so colour is there when you arrive.
        var scroll = $window.scrollTop() + $window.height() / 2;

        $panel.each(function () {
          var $this = $(this);

          // if position is within range of this panel.
          // So position of (position of top of div <= scroll position) && (position of bottom of div > scroll position).
          // Remember we set the scroll to 33% earlier in scroll var.
          if (
            $this.position().top <= scroll &&
            $this.position().top + $this.height() > scroll
          ) {
            // Remove all classes on body with color-
            $this.removeClass('bg-transition-active');
            $body.removeClass(function (index, css) {
              return (css.match(/(^|\s)bg-\S+/g) || []).join(' ');
            });

            // Add class of currently active div
            $body.addClass('bg-' + $(this).data('color'));
            $this.addClass('bg-transition-active');
          } else {
            $this.removeClass('bg-transition-active');
          }
        });
      })
      .scroll();
  }

  megamenuPopup() {
    var toggleBar = $('.navbar-toggle');
    var popupMenu = $('.megamenu-popup');
    var closePopup = $('.close-menu');
    $(toggleBar).click(function () {
      $(popupMenu).addClass('active');
    });
    $(closePopup).click(function () {
      $(popupMenu).removeClass('active');
    });
  }

  /*searchPopup() {
        var $toggleSearchLg = document.querySelectorAll('.mega-toggle-search__js'),
            $menuSearch = document.querySelector('.menu-search'),
            $body = document.querySelector('body');
        for (let i = 0; i < $toggleSearchLg.length; i++) {
            $toggleSearchLg[i].addEventListener(
                'click',
                (event) => {
                    event.preventDefault();
                    $menuSearch.classList.toggle('is-open');
                    $menuSearch.classList.toggle('is-closed');
                    if ( $( window ).width() >= 1280 ) {
                        $('body').toggleClass('overflow-hidden mega-menu--open theme-header--is-open');
                    }
                    $toggleSearchLg[i].classList.toggle('is-active');
                },
                false
            );
        }
    } */

  stickyBanner() {
    var cookie_name = $('#banner-info').attr('data-cookie-name');
    const modalclosetime = new Date(
      new Date().getTime() + 24 * 60 * 60 * 1000
    ).toLocaleString();
    var modalcookies = this.getCookie(cookie_name);
    var previous_cookie = this.getCookie('previous_cookie');
    var banner_info = $('#banner-info').val();
    if (!modalcookies && !banner_info) {
      // Set cookie with 30 days expiration time
      // document.cookie = "modal-timestamps="+ modalclosetime +"; max-age=" + 30*24*60*60;
      document.cookie =
        cookie_name +
        '=' +
        modalclosetime +
        '; max-age=' +
        1 * 24 * 60 * 60 +
        '; path=/';
      if (cookie_name != previous_cookie) {
        document.cookie =
          previous_cookie + '=' + cookie_name + '; max-age=0; path=/';
        document.cookie =
          'previous_cookie' +
          '=' +
          cookie_name +
          '; max-age=' +
          1 * 24 * 60 * 60 +
          '; path=/';
      }
    }

    $(document).on('click', '.alert-sticky .close', function () {
      // Set cookie with 30 days expiration time
      // document.cookie = "modal-timestamps="+ modalclosetime +"; max-age=" + 30*24*60*60;
      document.cookie =
        cookie_name +
        '=' +
        modalclosetime +
        '; max-age=' +
        1 * 24 * 60 * 60 +
        '; path=/';
      // if ( cookie_name != previous_cookie ) {
      //     document.cookie = previous_cookie + "="+ cookie_name +"; max-age=0; path=/";
      //     document.cookie = 'previous_cookie' + "="+ cookie_name +"; max-age=" + 90*24*60*60 +"; path=/";
      // }

      $('body').toggleClass('with-sticky-alert');
      $('body').css('padding-top', 0);
      $('.theme-header').css('top', 0);
      $('.alert-sticky').css('display', 'none');
      // $('.theme-wrap').css('opacity', 1);
      $('.menu-toggler').css('top', 34);
      $('.pushy').css('top', 190);
      if ($(window).width() < 1280) {
        $('.pushy').css('top', 170);
      }
      if ($(window).width() < 1025) {
        $('.pushy').css('top', 126);
      }
      if ($(window).width() < 768) {
        $('.pushy').css('top', 103);
      }
    });

    // var headerHeightFinal = $('.navbar-fixed-top').outerHeight()

    if ($('body').hasClass('with-sticky-alert')) {
      var alertHeight = $('.alert-sticky').outerHeight();
      $('body').css('padding-top', alertHeight);
      $('body').css('transition', 'all .3s ease');
      $('.theme-header').css('top', alertHeight);
      // $('.theme-wrap').css('opacity', 0);
      // setTimeout(() => {
      //     $('.theme-wrap').css('opacity', 1);
      //     $('.alert-sticky').css('opacity', 1);
      // }, "300")
      $('.menu-toggler').css('top', alertHeight + 34);
      $('.pushy').css('top', alertHeight + 190);
      if ($(window).width() < 1280) {
        $('.pushy').css('top', alertHeight + 170);
      }
      if ($(window).width() < 1025) {
        $('.pushy').css('top', alertHeight + 126);
      }
      if ($(window).width() < 768) {
        $('.pushy').css('top', alertHeight + 103);
      }
      if ($('body').hasClass('logged-in')) {
        $('.theme-header').css('top', alertHeight + 32);
        $('.menu-toggler').css('top', alertHeight + 66);
        $('.pushy').css('top', alertHeight + 222);
        if ($(window).width() < 1280) {
          $('.pushy').css('top', alertHeight + 202);
        }
        if ($(window).width() < 1025) {
          $('.pushy').css('top', alertHeight + 158);
        }
        if ($(window).width() < 768) {
          $('.pushy').css('top', alertHeight + 135);
        }
      }
    }
    // else if ($('body').hasClass('with-sticky-alert') && $(window).width() < 1280) {
    //     var alertHeight = $('.alert-sticky').outerHeight();
    //     this.bannerChange();
    //     $('.pushy').css('background', 'red');
    // }
    // else if ($(window).width() < 1024) {
    //     $(".pushy").css("top", alertHeight + 126);
    // }
    // else if ($(window).width() < 767) {
    //     $(".pushy").css("top", alertHeight + 103);
    // }
  }

  getCookie(cname) {
    let name = cname + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}

export default Header;
new Header();
